import React from 'react';
import Tag from '@bufferapp/ui/Tag';
import { NavTag } from '~/shared-components';

export const NewTag = <Tag color="green">New</Tag>;
export const BetaTag = <Tag color="teal">Beta</Tag>;
export const PaywallTag = <NavTag type="paywall" />;
